import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    BASE_URL, IMG_PRODUCTS_PUBLIC_URL_SERVER, MORE_PRODUCTS_DETAILS_POST, PUBLIC_URL_SERVER
} from "../../../../apis";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import imgPlayS from "../../../../images/base-image-product.jpg";
import axios from "axios";
import qs from "querystring";
import {
    actionChangeLoaderModalProduct,
    handelChangeDataSingleProduct,
    handelChangeSelectGradeModalProduct,
    handelOpenModalProduct
} from "../../../../redux/actions/modals/ModalProduct";


// import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
// import swal from "sweetalert";
import Swal from 'sweetalert2';

import Checkbox from '@mui/material/Checkbox';
import NumericInput from 'react-numeric-input';
import {
    actionChangeFoodPackageProductCheck, 
    actionChangeInputNumberProductInFoodPackage, 
    actionChangeNumOfCheckedProducts, 
    actionSetFoodPackChangedByUser} from "../../../../redux/actions/pages/foodPackage";



const CardProduct = (props) => {
    const dispatch = useDispatch();
    const {carts} = useSelector(state => state.shoppingCart);

    // const {token} = useSelector(state => state.user);
    const {unit, name, ourPrice, marketPrice, image, id, grade_title} = typeof props.product === "object" ? props.product : {
        unit: '',
        name: '',
        ourPrice: '',
        marketPrice: 0,
        image: '',
        grade_title: ''
    };

    const {num_of_checked_products} = useSelector(state => state.foodPackage);


    const handelChangeInputNumbers = (event) => {
        dispatch(actionChangeInputNumberProductInFoodPackage(id, props.isBasic, event))
    }

    const openModalProduct = () => {
        if(typeof props.forFoodPack !== undefined && props.forFoodPack === true) { // iteme package ghaza hast

        }
        else {
            // if (token) {
            //     apiGetDataSingleProduct();
            //     dispatch(handelOpenModalProduct());
            // } else {
            //     dispatch(handelOpenModalLoginAndRegister());
            // }
            apiGetDataSingleProduct();
            dispatch(handelOpenModalProduct());
        }
    };

    const apiGetDataSingleProduct = () => {
        dispatch(actionChangeLoaderModalProduct(true));
        axios({
            method: 'post',
            url: BASE_URL + MORE_PRODUCTS_DETAILS_POST,
            data: qs.stringify({
                product: id
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then((response) => {
            if (response.data.status === "ok") {
                dispatch(handelChangeDataSingleProduct(response.data.product, response.data.similar, response.data.options));

                const default_grade = response.data.product.grades.find(item => {
                    return item.default === '1' ? item : null;
                });

                if (carts.length > 0) {
                    const find_card = carts.find(cart => {
                        return cart.grades[0].gradeId === default_grade.gradeId ? cart : null;
                    });

                    if (find_card) {
                        dispatch(handelChangeSelectGradeModalProduct({
                            ...default_grade,
                            number_input: find_card.w_numbers
                        }, find_card.optionSelect));
                    } else {
                        dispatch(handelChangeSelectGradeModalProduct(default_grade));
                    }
                } else {
                    dispatch(handelChangeSelectGradeModalProduct(default_grade));
                }

                if (response.data.product.desc_show){
                    const btnOkSingle = Swal.mixin({
                        customClass: {
                            confirmButton: 'base-btn-green-border btn btn-success',
                        },
                        buttonsStyling: false
                    });
                    btnOkSingle.fire({
                        text: response.data.product.desc_show,
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "تایید",
                    });
                    // swal({
                    //     text: response.data.product.desc_show,
                    //     buttons: {
                    //         cancel: "تایید",
                    //     },
                    //     icon: "info",
                    // });
                }
            }
            dispatch(actionChangeLoaderModalProduct(false));
        });
    };



    const handleChangeCheckBox = (event) => {
        dispatch(actionChangeFoodPackageProductCheck(id, props.isBasic, event.target.checked));
        dispatch(actionSetFoodPackChangedByUser(true)); // tavasote karbar taghirati soorat gerefte
        if(event.target.checked)
            dispatch(actionChangeNumOfCheckedProducts(num_of_checked_products + 1));
        else
            dispatch(actionChangeNumOfCheckedProducts(num_of_checked_products - 1));
    }

    const label = { inputProps: { 'aria-label': 'Checkbox demo'} };

    return (
        <div className="box-card-product" onClick={openModalProduct} style={{opacity: props.forFoodPack ? (props.product.is_check ? "100%" : "60%") : "100%", padding: props.forFoodPack ? "5px 0px" : "5px 6px"}} id={'product-' + id}>

            {typeof props.forFoodPack !== undefined && props.forFoodPack === true ?
            <div >
                <Checkbox
                    {...label}
                    // checked={productChecked}
                    checked={props.product.is_check}
                    icon={
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29px" height="29px" viewBox="0 0 29 29" enable-background="new 0 0 29 29" xmlSpace="preserve">  <image id="image0" width="29" height="29" x="0" y="0"    href="data:image/png;base64,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" /></svg>
                    } 
                    checkedIcon={
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="29px" height="29px" viewBox="0 0 29 29" enable-background="new 0 0 29 29" xmlSpace="preserve">  <image id="image0" width="29" height="29" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAABOFBMVEVCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClCsClGsi6q256Y1IpJszGo2537/fr///+a1Y1LtDOr3J/9/vz4/Pel2ZlNtTas3KH+//73/Pad1pBOtTat3aKb1Y5XuUBfvEpPtTev3qT2+/Vjvk/K6cPS7MxgvEtPtjiw3qaW04m24KzR7MtivU2z36mU0oZ5x2fj89+24a2R0YNuw1vT7M1mv1FQtjm54q/1+/SQ0YFDsCpswVjh8t3O68iAym+y36j0+vKMz31EsSxrwVfg8tzv+O3z+vKKznpFsSxpwFXe8drw+e6HzXdowFTc8Nj8/vyX1Ip0xWE9T3tTAAAAHnRSTlMAGm2r2PDbrDCv/P0IkpMbzxzgCdAybK3xCtEx2a67W/7bAAAAAWJLR0QlwwHJDwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+YEDBIqIY8/4C8AAAFMSURBVCjPjZNpV4JQEIYvhCJhICIIVrc0pz1tL7Oyfbeyfd+X//8PuoCX3XN6P8Cc8zD3DjPvIETFsF1cAieSPMugsFJCN6YShVSApXtE7JcopT0oZ3BYGZlCJYujyioOVHM4TjnVphKOl2RBTexARY1QIQYMDBZLGAuk3pjU0lAZhkmyjPQoHBkdg/EJEuiIj8DJqQpUp60oj7gwnJkFqM7ZIYcM6zW/4MLFJYDlohMbyHrWVuqrbbi2TmCDfmrnbgBsbjlwm8AdCg373t09gHrNgvsEHri3cE7NhwQfHeOTJsDp2blL8+3/bV0AXF5dV+Dm9s4rX6e9un8AeCzD0/OLr9GK2+fXNwB4//BBq8/ujD6/4PvHd6wzI3e+reavP9OZLzI7eMP8h6/IjAsRWJA9y6pS2M9mwO+9gV3QIrvCsHyfgY1kv2+P/gDQfVlvBPWhMgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wNC0xMlQxNTo0MjozMyswMzowMFJ8D/oAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDQtMTJUMTU6NDI6MzMrMDM6MDAjIbdGAAAAAElFTkSuQmCC" /></svg>
                    }
                    sx={{
                        color: '#898d91',
                        '&.Mui-checked': {
                            color: '#48ad17',
                        },
                        '& .MuiSvgIcon-root': { fontSize: 35 },
                        '&.MuiCheckbox-root': { position: 'absolute'}
                    }}
                    onChange={handleChangeCheckBox}
                />
            </div>
            : '' }

            <div className={'box-card-image-product'}>
                <LazyLoadImage
                    src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + image} // use normal <img> attributes as props
                    placeholderSrc={imgPlayS}
                    alt={name}
                />
            </div>

            {typeof props.forFoodPack !== undefined && props.forFoodPack === true ?
            <div className={'my-2'}>
                <NumericInput
                    className="form-control cm-react-numeric-input"
                    value={props.product.selectedAmount}
                    format={(num) => (num + `  ${unit}`)}
                    step={(component, direction) => {
                        switch (direction) {
                            case "up":
                                handelChangeInputNumbers('up');
                                break;
                            case "down":
                                handelChangeInputNumbers('down');
                                break;
                            default:
                        }
                    }}
                    size={5}
                    mobile
                    onChange={handelChangeInputNumbers}
                    max={100}
                />
            </div>
            : '' }

            <div className={'box-body-card-product'}>
                <div className="item-info-body-card-product">
                    <span className="unit-card-product">هر {unit}</span>
                    <div className="item-info-price-card-product">

                        {marketPrice !== "0" && marketPrice !== null ?
                            <React.Fragment>
                                <span
                                    className="item-info-price-real-card-product">{parseInt(marketPrice).toLocaleString()}  تومان</span>
                                <span
                                    className="item-info-price-offer-card-product">{parseInt(ourPrice) !== 0 ? parseInt(ourPrice).toLocaleString() + 'تومان' : 'رایگان'}</span>
                            </React.Fragment>
                            :
                            <span
                                className="item-info-price-offer-card-product">{parseInt(ourPrice) !== 0 ? parseInt(ourPrice).toLocaleString() + ' تومان' : ' رایگان'}</span>
                        }
                    </div>
                </div>
                <div className="item-info-body-card-product mt-1">
                    <span>{name}</span>
                </div>
                <div className="item-info-body-card-product mt-1">
                    {grade_title}
                </div>
                {marketPrice !== "0" && marketPrice !== null ?
                    <div className="item-info-body-card-product box-item-show-info-offer">
                        <p>
                            <span>{(Math.abs(ourPrice - marketPrice)).toLocaleString()}</span>
                            <span> تومان تخفیف</span>
                        </p>
                    </div>
                    : ''}
            </div>
        </div>
    );
};

export default CardProduct;
